// iter586 — „Моят циркаден прозорец" — inline expand на DIL tile-а.
// Чете GET /api/dil/circadian-window (services/circadian_metabolism.py) с
// локалния час на потребителя → личен времеви прозорец без модал.
import React, { useState } from "react";
import axios from "axios";

const BUCKET_COLORS = {
  morning: "#10B981",
  midday: "#84CC16",
  afternoon: "#F59E0B",
  evening: "#F97316",
  night: "#EF4444",
};

export default function CircadianWindow({ API, isDark, bg }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const toggle = async () => {
    if (open) { setOpen(false); return; }
    setOpen(true);
    if (!data) {
      setLoading(true);
      try {
        const { data: d } = await axios.get(`${API}/dil/circadian-window?hour=${new Date().getHours()}`);
        setData(d);
      } catch {
        // silent — панелът показва loading/empty state
      }
      setLoading(false);
    }
  };

  return (
    <div className="px-5 pb-4 -mt-1">
      <button
        type="button"
        onClick={toggle}
        data-testid="cc-circadian-toggle"
        className={`inline-flex items-center gap-1.5 text-xs font-semibold rounded-full px-3 py-1.5 transition-colors ${
          isDark ? "bg-white/5 text-amber-200 hover:bg-white/10" : "bg-amber-50 text-amber-800 hover:bg-amber-100"
        }`}
      >
        🕒 {bg ? "Моят циркаден прозорец" : "My circadian window"}
        <span className={`transition-transform ${open ? "rotate-180" : ""}`}>▾</span>
      </button>

      {open && (
        <div className="mt-3 space-y-3" data-testid="cc-circadian-panel">
          {loading && (
            <div className={`text-xs ${isDark ? "text-gray-400" : "text-gray-500"}`}>
              {bg ? "Изчисляваме прозореца ти…" : "Computing your window…"}
            </div>
          )}
          {!loading && data && (
            <>
              {/* Текущ прозорец + множител */}
              <div className="flex items-center justify-between gap-2">
                <span className={`text-xs font-bold ${isDark ? "text-white" : "text-[#1A1A2E]"}`}>
                  {bg ? data.label_bg : data.label_en}
                </span>
                <span
                  className="shrink-0 text-[11px] font-extrabold px-2 py-0.5 rounded-full"
                  style={{
                    color: BUCKET_COLORS[data.bucket],
                    backgroundColor: `${BUCKET_COLORS[data.bucket]}1A`,
                  }}
                  data-testid="cc-circadian-multiplier"
                >
                  ×{data.multiplier}{data.delta_pct > 0 ? ` (+${data.delta_pct}%)` : ""}
                </span>
              </div>

              {/* Личен съвет — „хранене до HH:00 → запазваш X% бюджет" */}
              <div
                className={`text-xs leading-relaxed rounded-xl px-3 py-2.5 ${
                  isDark ? "bg-amber-500/10 text-amber-100" : "bg-amber-50 text-amber-900"
                }`}
                data-testid="cc-circadian-tip"
              >
                💡 {bg ? data.tip_bg : data.tip_en}
              </div>

              {/* 5-сегментна времева лента — текущият прозорец е маркиран */}
              <div className="flex gap-1" data-testid="cc-circadian-timeline">
                {(data.windows || []).map((w) => (
                  <div key={w.bucket} className="flex-1 text-center">
                    <div
                      className={`h-2 rounded-full ${w.is_current ? "ring-2 ring-offset-1" : "opacity-40"}`}
                      style={{
                        backgroundColor: BUCKET_COLORS[w.bucket],
                        ...(w.is_current ? { "--tw-ring-color": BUCKET_COLORS[w.bucket], ringOffsetColor: isDark ? "#0B1120" : "#fff" } : {}),
                      }}
                    />
                    <div className={`mt-1 text-[9px] tabular-nums ${w.is_current ? "font-bold" : ""} ${isDark ? "text-gray-400" : "text-gray-500"}`}>
                      {w.hours.replace("–", "‑").split("‑")[0].replace(":00", "")}ч
                    </div>
                  </div>
                ))}
              </div>

              <p className={`text-[10px] leading-relaxed ${isDark ? "text-gray-500" : "text-gray-400"}`}>
                {bg
                  ? "Същата храна → различен инсулинов товар според часа (Saad 2012). Множителят се прилага автоматично върху DIL-а на всяко записано хранене."
                  : "Same food → different insulin load by hour (Saad 2012). The multiplier is applied automatically to every logged meal's DIL."}
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
}
